/**
 * Description: Data containing Login credentials
 * Author : Guryash Singh Dhall
 * From Scratch
 **/
export const userCreds = [{
  name: "John Brown",
  email: "johnbrown@gmail.com", // entrepreneur creds
  password: "john@1234",
  userType: "entrepreneur"
},
{
  name: "Olivia Mathew",
  email: "oliviaInvestor@gmail.com", //investor creds
  password: "Investor@1234",
  userType: "investor"
},
];
